import { Tab, Tabs, Typography } from "@mui/material";
import { JobLog, JobStepsDone, WebAutomationAction } from "generated-graphql/graphql";
import { useState } from "react";

import type { ReportJob } from "./types";

import { LogsTab } from "./LogsTab";
import { type ScreenshotItem, ScreenshotsTab } from "./ScreenshotsTab";
import { StepsDoneTab } from "./StepsDoneTab";

export interface JobDetailTabsProps {
  job: ReportJob | null;
  logs: JobLog[];
  stepsDone: JobStepsDone[];
  screenshotSrcs: ScreenshotItem[];
  onDeleteStep: (step: JobStepsDone) => void;
}

export function JobDetailTabs({
  job,
  logs,
  stepsDone,
  screenshotSrcs,
  onDeleteStep,
}: JobDetailTabsProps) {
  const [detailTab, setDetailTab] = useState(0);
  const showChemicalProgress =
    job?.action === WebAutomationAction.InputData ||
    job?.action === WebAutomationAction.InputDataRevision ||
    job?.action === WebAutomationAction.InputDataLepc;

  if (!job) {
    return (
      <Typography color="text.secondary">
        Select a job to view logs, steps, and screenshots.
      </Typography>
    );
  }

  return (
    <>
      <Tabs value={detailTab} onChange={(_, v: number) => setDetailTab(v)} sx={{ mb: 2 }}>
        <Tab label="Steps done" />
        <Tab label="Logs" />
        <Tab label="Screenshots" />
      </Tabs>
      {detailTab === 0 && (
        <StepsDoneTab
          stepsDone={stepsDone}
          onDeleteStep={onDeleteStep}
          showChemicalProgress={showChemicalProgress}
        />
      )}
      {detailTab === 1 && <LogsTab logs={logs} />}
      {detailTab === 2 && <ScreenshotsTab screenshotSrcs={screenshotSrcs} />}
    </>
  );
}
